import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconNeutral = function IconNeutral(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 52 52",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 2C12.745 2 2 12.745 2 26s10.745 24 24 24 24-10.745 24-24S39.255 2 26 2zm-1.5 14.625a1.5 1.5 0 013 0v14a1.5 1.5 0 01-3 0v-14zm1.5 20.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 52 52",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 5c11.58 0 21 9.42 21 21s-9.42 21-21 21S5 37.58 5 26 14.42 5 26 5m0-3C12.745 2 2 12.745 2 26s10.745 24 24 24 24-10.745 24-24S39.255 2 26 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 35.625,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 32.125a1.5 1.5 0 01-1.5-1.5v-14a1.5 1.5 0 013 0v14a1.5 1.5 0 01-1.5 1.5z"
  })));
};

export default IconNeutral;
